<template>
  <div id="mainBlockSelector">
    <div class="contentBox" v-if="!isBlockSelector">
<!--    <div class="contentBox" v-bind:class="{disable:isBlockSelector}">-->
      <div>
        <h3 >Выберите сумму займа</h3>
        <formSelect :refs="'CALC_SUMM'" :type="'deal'"></formSelect>
        <div class="slWrap" >
<!--          <p>Вы получите:<b>{{getSelectedDeal.Amount | moneyFormat}} ₽</b>на {{getSelectedDeal.loanPeriod}} {{getSelectedDeal.PeriodType}}</p>-->
          <range-slider
              class="slider"
              :min="0"
              :max="getActiveDistinctAmount.length - 1"
              :step="1"
              v-model="rangeValueSumm">
          </range-slider>
          <div class="fromTo">
            <p class="pa">от {{getActiveMinDeal | moneyFormat}} ₽</p>
            <p class="pb">до {{getActiveMaxDeal | moneyFormat}} ₽</p>
          </div>
        </div>
        <formSelect :refs="'CALC_WEEK'" :type="'deal'"></formSelect>
        <div class="slWrap">
          <range-slider
              class="slider"
              :min="0"
              :max="getActiveDistinctPeriod.length - 1"
              :step="1"
              v-model="rangeValuePeriod">
          </range-slider>
          <div class="flex">
            <p
                v-for="(item,index) in getActiveDistinctPeriod"
                v-bind:key="index"
                class="descTxt"
            >
              <span>{{item.name}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="greenBorder" v-if="isOnline">
        <div>
          <div class="onOffLine">
            <h2>Условия займа</h2>
            <p style="background: #45B537" class="onOfflineLabel">ONLINE</p>
          </div>
          <div>
            <div class="border">
              <p class="blackText" style="font-family: 'Lato-Bold'">Деньги поступят вам на карту после<br> одобрения заявки</p>
            </div>
            <div>
              <p class="blackText">Время ожидания:</p>
              <p>до 15 минут</p>
            </div>
            <div>
              <p>Вы получите:</p>
              <p>{{getSelectedDeal.Amount | moneyFormat}} ₽</p>
            </div>
            <!--          <div>-->
            <!--            <p>Вернуть:</p>-->
            <!--            <p class="green">{{getSelectedDeal.OutPayments | moneyFormat}} ₽</p>-->
            <!--          </div>-->
             <div>
              <p>Дата возврата: </p>
              <p class="green">{{getSelectedDeal.payDay}}</p>
             </div>
<!--            <div>-->
<!--              <p>На срок: </p>-->
<!--              <p>{{getSelectedDeal.loanPeriod}} {{getSelectedDeal.PeriodType}}-->
<!--&lt;!&ndash;                ({{getSelectedDeal.FixedPay| moneyFormat}} ₽/нед) &ndash;&gt;-->
<!--              </p>-->
<!--            </div>-->
<!--            <div>-->
<!--              <p>Со ставкой: </p>-->
<!--              <p class="round">{{getSelectedDeal.rate}}%</p>-->
<!--            </div>-->
            <div>
              <p>Вы вернёте: </p>
              <p class="green bgRevers">{{getSelectedDeal.OutPayments | moneyFormat}} ₽</p>
            </div>
            <div v-if="tmpSaleCalc > 0">
              <p>Сумма погашения</p>
              <p>{{tmpSaleCalc | moneyFormat}} ₽</p>
            </div>
          </div>
        </div>
      </div>
      <div class="purpleBorder" v-if="!isOnline">
        <div>
          <div class="onOffLine">
            <h2 >Условия займа</h2>
            <p style="background: #991E66" class="onOfflineLabel">OFFLINE</p>
          </div>
          <div>
            <div class="border">
              <p style="font-family: 'Lato-Bold'" class="">Деньги поступят на ваш расчетный счет
                после дополнительного общения с персональным менеджером</p>
            </div>
            <div>
              <p class="blackText">Время ожидания:</p>
              <p>До 24 часов</p>
            </div>
            <div>
              <p>Вы получите:</p>
              <p>{{getSelectedDeal.Amount | moneyFormat}} ₽</p>
            </div>
            <!--          <div>-->
            <!--            <p>Вернуть:</p>-->
            <!--            <p class="green">{{getSelectedDeal.OutPayments | moneyFormat}} ₽</p>-->
            <!--          </div>-->
            <!--          <div>-->
            <!--            <p>До (включительно): </p>-->
            <!--            <p class="green">{{getSelectedDeal.payDay}}</p>-->
            <!--          </div>-->
            <div>
              <p>На срок: </p>
              <p>{{getSelectedDeal.loanPeriod}} {{getSelectedDeal.PeriodType}}</p>
            </div>
            <div>
              <p>Еженедельный платёж составит: </p>
              <p>{{getSelectedDeal.FixedPay | moneyFormat}}₽</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button v-on:click="navigationEmit('zform', $event)" v-if="showButton">Получить деньги</button>
  </div>
</template>

<script>
  import {mapState,mapGetters} from 'vuex'
  import RangeSlider from 'vue-range-slider'
  import 'vue-range-slider/dist/vue-range-slider.css'
  export default {
    name: "uiProductAmountSelector",
    props:{
      currentScreen:{
        type:String,
        default:'',
      },
      showButton:{
        type:Boolean,
        default: true
      }
    },
    components: {
      RangeSlider,
      formSelect:   () => import('@/views/pdlloan/formSelect'),
    },
    data(){
      return{
        ttt:0
      }
    },
    methods:{

      navigationEmit(id, $event) {

        this.$emit('scrollingTo', {
          id:id,
          event:$event
        })
      },

    },
    computed:{
      ...mapGetters([
        'getSelectedDeal',
        'getActiveDistinctAmount',
        'getActiveMinDeal',
        'getActiveMaxDeal',
        'getActiveDistinctPeriod',
        'getActiveCalcSummIndex',
        'getActiveCalcWeekIndex'
      ]),
      ...mapState({
        valueVuex: state => state.Form.sendData,
      }),
      isOnline() {
        // return this.valueVuex.CALC_WEEK < 52;
        return this.getSelectedDeal.vwIsPdl === '1';
      },
      rangeValueSumm:{
        get(){
          // console.log('i work rangeValueSumm')
          // localStorage.setItem('CALC_SUMM',this.getActiveCalcSummIndex);
          return this.getActiveCalcSummIndex;
        },
        set(value){
          this.$store.dispatch('saveSendData', {
            target: 'CALC_SUMM',
            value: this.getActiveDistinctAmount[value].value
          });

        }
      },
      rangeValuePeriod:{
        get(){
          // localStorage.setItem('CALC_WEEK',this.getActiveCalcWeekInde);
          return this.getActiveCalcWeekIndex;
        },
        set(value){
          this.$store.dispatch('saveSendData', {
            target: 'CALC_WEEK',
            value: this.getActiveDistinctPeriod[value].value
          });

        }
      },
      isBlockSelector(){
        //хотелка Трифонова на мобильникох блочить калькулятор если прошли хотя бы первый экран
        //блочить на этапе подписания
        // return window.outerWidth < 760 && this.currentScreen != 'fio' || this.currentScreen == 'signingLoan';
        //новое хотю, блочим калькулятор если ушли с фио. ибо можем подсасать лимит или с продукта на продукт перескочить
        return  this.currentScreen != 'fio';
      },
      tmpSaleCalc(){
        let out = 0;
        if(this.getSelectedDeal.SaleForVirgin) {
          console.log(this.getSelectedDeal.Amount <= 5000 && this.getSelectedDeal.loanPeriod <= 14)
          if(this.getSelectedDeal.Amount <= 5000 && this.getSelectedDeal.loanPeriod <= 14) {
            // out = (this.getSelectedDeal.OutPayments - this.getSelectedDeal.Amount) * (-1);
            out = this.getSelectedDeal.Amount;
          }
        }
        return out;
      }
    },
    watch:{

    },
    mounted(){


    }
  }
</script>

<style scoped>
span { font-size: 2.94vw }
.contentBox { width: 100%;  min-height: unset; margin-bottom: 12.65vw; box-sizing: border-box; box-shadow: 0 1.33vw 6.93vw rgba(0,0,0,.10196078431372549); border-radius: 6.93vw; float: right; display: flex; flex-direction: column; align-items: center}
.contentBox > div:first-child { padding: 10.67vw 6.93vw; width: calc(100% - 19.86vw);}
.contentBox { width: 100%;  min-height: unset; margin-bottom: 12.65vw; box-sizing: border-box; box-shadow: 0 1.33vw 6.93vw rgba(0,0,0,.10196078431372549); border-radius: 10px; float: right; display: flex; flex-direction: column; align-items: center}
.contentBox > div:first-child { padding: 10.67vw 6.93vw; }
.contentBox > div > h3 { font-family: 'Lato-Bold'; padding-bottom: 7.65vw; text-align: center }
.contentBox > div > h2 { font-family: 'Lato-Bold'; }
#mainBlockSelector > button { border-radius: 4.27vw; margin: 0 auto 12.65vw auto; width: 88.24vw }
.slWrap > p { text-align: center; text-transform: lowercase }
.slWrap > p > b { text-align: center; padding: 0 1.33vw }
.slider { width: 100%; box-sizing: border-box; padding: 0; margin-bottom: 2.94vw  }
.fromTo { display: flex; padding: 0 6.93vw; justify-content: space-between; }
.fromTo > p { margin-bottom: 4.41vw; font-size: 2.94vw }
.flex { display: flex; justify-content: space-between }
.flex > p {  }
/deep/ .slider > .range-slider-inner > .range-slider-hidden { display: none; }
/deep/ .slider > .range-slider-inner > .range-slider-rail { background-color: #43AC34; }
/deep/ .slider > .range-slider-inner > .range-slider-fill { background-color: #0C5A44; }
/deep/ .slider > .range-slider-inner > .range-slider-knob { border: 0.27vw solid #0D5740; background-color: #0D5740; box-shadow: inset 0 0 0 0.13rem white; width: 4.27vw; height: 4.27vw; }
.disable{pointer-events: none}
.onOffLine { display: flex; justify-content: space-between }
.onOfflineLabel { height: 7.35vw; width: 25.59vw; color: #FFFFFF; display: flex; align-items: center; justify-content: center; font-size: 4.71vw }
.greenBorder { background-color: #0D5740; width: 100vw; border-radius: 10px; padding: 10vw 0; }
.greenBorder > div { background-color: #fff;width: 81.18vw; border-radius: 10px; padding: 3.53vw 4.71vw 5.29vw 4.71vw; margin: 0 auto}
.greenBorder > div > .onOffLine > h2 { font-family: 'Lato-Bold'; margin-bottom: 2.94vw; font-size: 5.59vw }
.greenBorder > div > div > div { display: flex; justify-content: space-between; padding-top: 2.97vw; ; color: #45B537 }
.greenBorder > div > div > div > p:last-child { font-family: 'Lato-Bold'}
.greenBorder > div > div > div > .blackText { color: black }
.greenBorder > div > div > .border { color: #45B537; border-top: 1px solid #0C5A44; padding-top: 6.47vw }
.greenBorder > div > div > div > .round { padding: 0 1.47vw;height: 5.88vw; border-radius: 2.35vw; background: #45B537; color: #FFFFFF; display: flex; align-items: center; justify-content: center; }
.purpleBorder { background-color: #991E66; width: 100vw; border-radius: 10px; padding: 10vw 0;  }
.purpleBorder > div { background-color: #fff;width: 81.18vw; border-radius: 10px; padding: 3.53vw 4.71vw 5.29vw 4.71vw; margin: 0 auto}
.purpleBorder > div > .onOffLine > h2 { font-family: 'Lato-Bold'; margin-bottom: 2.94vw; font-size: 5.59vw }
.purpleBorder > div > div > div { display: flex; justify-content: space-between; padding-top: 2.97vw; color: #991E66 }
.purpleBorder > div > div > div > p { }
.purpleBorder > div > div > div > .blackText { color: black }
.purpleBorder > div > div > .border { color: #991E66; border-top: 1px solid #0C5A44; padding-top: 6.47vw }
.purpleBorder > div > div > div > .round { padding: 0 1.47vw;height: 5.88vw; border-radius: 2.35vw; background: #991E66; color: #FFFFFF; display: flex; align-items: center; justify-content: center; }
#mainBlockSelector { display: flex; flex-direction: column; align-items: center; background-color: #fff }
.nextStepBlock { display: flex; align-items: center; }
.nextStepBlock > p { display: flex; align-items: center; }
.nextStepBlock > button { border-radius: 2.67vw; width: 56vw; padding: 4.27vw; height: 12.27vw}
.bgRevers{background: #45B537;color:white;padding: 1vw;border-radius: 6px;}

@media (min-width: 760px) {
  span { font-size: 0.97vw }
  /*.descTxt {font-size: .52rem;}*/
  .contentBox { width: 33.87vw; border-radius: 10px; padding: 3.23vw 3.23vw 0; margin-bottom: 4.44vw;
    background: #FFF; }
  .contentBox > div { padding: 2.10vw 0 }
  .contentBox > div:first-child { padding: 0 ;width: 100%;}
  .contentBox > div > h3 { margin-bottom: 2.58vw; padding: 0; font-size: 1.45vw }
  .contentBox > div > h2 { }
  /deep/ .slider { margin-bottom: 0.97vw }
  /deep/ .slider > .range-slider-inner > .range-slider-knob { border: 0.17vw solid #0D5740; background-color: #0D5740; box-shadow: inset 0 0 0 0.13rem white; width: 1.37vw; height: 1.37vw; }
  /deep/ .slider > .range-slider-inner > .range-slider-rail { height: 2px }
  /deep/ .slider > .range-slider-inner > .range-slider-fill { height: 2px }
  .slWrap > p { }
  .fromTo > p { font-size: 0.97vw; margin-bottom: 1.61vw }
  .flex > p { }
  .onOfflineLabel { height: 2.02vw; width: 7.02vw; font-size: 1.29vw }
  .greenBorder { width: 33.87vw}
  .greenBorder > div { width: 26.69vw; padding: 1.21vw 1.53vw}
  .greenBorder > div > .onOffLine > h2 { margin-bottom: 0.97vw; font-size: 1.94vw }
  .greenBorder > div > div > .border { padding-top: 2.26vw }
  .greenBorder > div > div > div { padding-top: 1.13vw }
  .greenBorder > div > div > div > p { }
  .greenBorder > div > div > div > .round {  height: 2.02vw; border-radius: 10px; padding: 0 0.97vw }
  .purpleBorder { width: 33.87vw}
  .purpleBorder > div { width: 26.69vw; padding: 1.21vw 1.53vw}
  .purpleBorder > div > .onOffLine > h2 { margin-bottom: 0.97vw; font-size: 1.94vw }
  .purpleBorder > div > div > .border { padding-top: 2.26vw }
  .purpleBorder > div > div > div { padding-top: 1.13vw }
  .purpleBorder > div > div > div > p { }
  .purpleBorder > div > div > div > .round {  height: 2.02vw; border-radius: 10px; padding: 0 0.97vw }
  #mainBlockSelector { background: none ;}
  #mainBlockSelector > button { border-radius: 15px; width: 28.23vw; margin-bottom: 0.65vw }
  .fromTo { margin-bottom: 1.45vw; padding: 0 }
  .flex { margin-bottom: 1.21vw }
  .nextStepBlock { display: flex; align-items: center; justify-content: flex-end; margin-bottom: 4.27vw }
  .nextStepBlock > p { display: flex; align-items: center; }
  .nextStepBlock > button { border-radius: 10px; width: 16.13vw; padding: 1.29vw 2.10vw; height: 4.03vw; margin: 0 0 0 1.94vw }
  .bgRevers{padding: 0.4vw;}
  }
@media (min-width: 1240px) {
  span { font-size: 12px }
  .descTxt { }
  .contentBox { width: 420px; border-radius: 10px; padding: 40px 38px 0; margin-bottom: 55px; background: #FFF; }
  .contentBox > div { padding: 26px 0 }
  .contentBox > div:first-child { padding: 0 }
  .contentBox > div > h3 { margin-bottom: 32px; padding: 0; font-size: 18px }
  .contentBox > div > h2 {  }
  /deep/ .slider { margin-bottom: 5px }
  /deep/ .slider > .range-slider-inner > .range-slider-knob { border: 2px solid #0D5740; box-shadow: inset 0 0 0 2px white; width: 17px; height: 17px; }
  .slWrap > p { opacity: 0.4 }
  .fromTo > p { opacity: 0.4; font-size: 12px }
  .flex > p { opacity: 0.4 }
  .onOfflineLabel { height: 25px; width: 87px; font-size: 16px }
  .greenBorder { width: 420px }
  .greenBorder > div { width: 331px; padding: 15px 19px}
  .greenBorder > div > .onOffLine > h2 { margin-bottom: 12px; font-size: 24px }
  .greenBorder > div > div > .border { padding-top: 28px }
  .greenBorder > div > div > div { padding-top: 14px }
  .greenBorder > div > div > div > p { }
  .greenBorder > div > div > div > .round {  height: 25px; border-radius: 10px; padding: 0 12px }
  .purpleBorder { width: 420px }
  .purpleBorder > div { width: 331px; padding: 15px 19px}
  .purpleBorder > div > .onOffLine > h2 { margin-bottom: 12px; font-size: 24px }
  .purpleBorder > div > div > .border { padding-top: 28px }
  .purpleBorder > div > div > div { padding-top: 14px }
  .purpleBorder > div > div > div > p { }
  .purpleBorder > div > div > div > .round {  height: 25px; border-radius: 10px; padding: 0 12px }
  #mainBlockSelector {}
  #mainBlockSelector > button { width: 350px; margin-bottom: 8px }
  .fromTo { margin-bottom: 18px; padding: 0 }
  .flex { margin-bottom: 1.21vw }
  .nextStepBlock { margin-bottom: 4.27vw }
  .nextStepBlock > p {  }
  .nextStepBlock > button { border-radius: 10px; width: 16.13vw; padding: 1.29vw 2.10vw; height: 4.03vw; margin: 0 0 0 1.94vw }
  .bgRevers{padding: 4px;}
}


</style>
